const styles = theme => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'flex-end',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: 0,
    width: 'calc(100% - 48px)',
  },
  caption: {
    fontSize: '0.9em',
  },
  activate: {
    fontSize: '0.8em',
    fontWeight: 200,
    marginTop: theme.spacing.unit * 2,
  },
  termsContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  terms: {
    textAlign: 'center',
    width: 450,
    fontSize: '1em',
  },
  headerImage: {
    width: '100%',
  },
  actions: {
    marginTop: theme.spacing.unit * 2,
  },
  inputContainer: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  menu: {
    width: 200,
  },
  formControl: {
    width: '97%',
    border: '2px solid #999',
    padding: '16px 2px 12px 16px',
    margin: '16px 0',
  },
  formLabel: {
    top: -8,
    left: 12,
    position: 'absolute',
    display: 'block',
    background: 'white',
    width: 'fit-content',
    padding: '0 12px',
    textAlign: 'center',
  },
  location: {
    width: '30%',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/UpgradeDialog/styles.js